import { configuredAxios as api } from './axiosConfig';

/**
 * Registra um novo jogador no mercado.
 * @param {FormData} formData - Os dados do formulário, incluindo fotos.
 * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
 */
const register = async (formData) => {
  try {
    const res = await api.post('/market', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return {
      success: true,
      data: res.data.data || null,
      error: null
    };
  } catch (err) {
    console.error('Error registering player:', err);
    return {
      success: false,
      data: null,
      error: err.response?.data?.error || 'Failed to register player'
    };
  }
};

/**
 * Busca jogadores de um campeonato específico.
 * @param {string} championshipId - O ID do campeonato.
 * @returns {Promise<{success: boolean, data: Array, count: number, error: string|null}>}
 */
const getByChampionship = async (championshipId) => {
  try {
    const res = await api.get(`/market/championship/${championshipId}`);
    return {
      success: true,
      data: res.data.data || [],
      count: res.data.count || 0,
      error: null
    };
  } catch (err) {
    console.error('Error fetching players by championship:', err);
    return {
      success: false,
      data: [],
      count: 0,
      error: err.response?.data?.error || 'Failed to fetch players by championship'
    };
  }
};

/**
 * Busca todos os jogadores do mercado, com filtros opcionais.
 * @param {object} params - Parâmetros de query (ex: { position: 'Atacante' }).
 * @returns {Promise<{success: boolean, data: Array, count: number, error: string|null}>}
 */
const getAll = async (params = {}) => {
  try {
    const res = await api.get('/market', { params });
    return {
      success: true,
      data: res.data.data || [],
      count: res.data.count || 0,
      error: null
    };
  } catch (err) {
    console.error('Error fetching players:', err);
    return {
      success: false,
      data: [],
      count: 0,
      error: err.response?.data?.error || 'Failed to fetch players'
    };
  }
};

// --- NOVAS FUNÇÕES ADICIONADAS ---

/**
 * Busca um jogador específico pelo seu ID.
 * @param {string} id - O ID do jogador.
 * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
 */
const getById = async (id) => {
  try {
    const res = await api.get(`/market/${id}`);
    return { success: true, data: res.data.data, error: null };
  } catch (err) {
    console.error(`Error fetching player with ID ${id}:`, err);
    return {
      success: false,
      data: null,
      error: err.response?.data?.error || 'Failed to fetch player details'
    };
  }
};

/**
 * Atualiza os dados de um jogador existente.
 * @param {string} id - O ID do jogador a ser atualizado.
 * @param {FormData} formData - Os novos dados do formulário.
 * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
 */
const update = async (id, formData) => {
  try {
    const res = await api.put(`/market/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return { success: true, data: res.data.data, error: null };
  } catch (err) {
    console.error(`Error updating player with ID ${id}:`, err);
    return {
      success: false,
      data: null,
      error: err.response?.data?.error || 'Failed to update player'
    };
  }
};


export default {
  register,
  getByChampionship,
  getAll,
  getById, // <-- Exportando a nova função
  update,  // <-- Exportando a nova função
};